import moment from "moment";
import jwt from 'jsonwebtoken';
import {StorageUtils} from "./StorageUtils";

export class JWTUtils {

	static getPayload = (token: string = StorageUtils.getAuthorization()) => {
		if (!token) return null;
		try {
			return jwt.decode(token, {});
		} catch (e) {
			console.error(e);
		}
		return null;
	};

	static checkExp(payload = JWTUtils.getPayload()) {
		return payload.exp > moment().unix();
	};

	static checkNbf(payload = JWTUtils.getPayload()) {
		return payload.nbf <= moment().unix();
	};

	static isAuthenticated() {
		const jwt = JWTUtils.getPayload();
		return jwt && JWTUtils.checkNbf(jwt) && JWTUtils.checkExp(jwt);
	};
}
